<template>
  <BaseViewComponent
    name="promo"
    :is-preview="isPreview"
  >
    <div class="promo-wrapper full-width">
      <div class="container flex">
        <div class="left">
          <div class="title-h4">
            {{ pageData.promoSubtitle }}
          </div>
          <div class="title-h2">
            {{ pageData.promoTitle }}
          </div>
          <div class="text-p">
            {{ pageData.promoText }}
          </div>
          <BaseButton
            :label="pageData.promoButtonText"
          />
          <div class="note">
            {{ pageData.promoNote }}
          </div>
        </div>
        <div class="right text-center relative-position">
          <div
            v-if="isPromoVideo && promoMedia"
            class="iframe-wrapper"
          >
            <iframe
              :src="promoMedia"
              class="video border-radius-12"
            />
          </div>
          <div
            v-else
            class="relative-position"
          >
            <img
              class="frame relative-position"
              src="/landing/promo-frame.png"
              width="100%"
            >
            <img
              class="absolute image"
              :src="promoMedia ? getCompressImage(promoMedia) : '/landing/call-to-action-cover.png'"
              width="100%"
            >
          </div>
          <div class="gradient absolute" />
        </div>
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseButton from 'components/book-landing/render/BaseButton.vue';
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import getCompressImage from 'src/helpers/getCompressImage';

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const {
  promoMedia,
  isPromoVideo,
} = useBookPageEdit();

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);
</script>

<style lang="scss" scoped>
</style>
